module.exports = __webpack_public_path__ + "static/media/default-photo2.2f009edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/default-photo2.png
// module id = 867
// module chunks = 0